import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { ClientPowerBIReport } from '@power-bi/models/client-power-bi-report';
import { FindByPropertyPipe } from '@shared/pipes/find-by-property.pipe';
import { SortPipe } from '@shared/pipes/sort.pipe';

@Component({
  selector: 'app-report-picker',
  templateUrl: './report-picker.component.html',
  styleUrls: ['./report-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    SortPipe,
    FindByPropertyPipe,
    NgClass
  ]
})
export class ReportPickerComponent {
  readonly reports = input<ClientPowerBIReport[]>([]);
  readonly selectedReportId = input<string | null>(null);
  readonly disabled = input(false);

  readonly selected = output<ClientPowerBIReport>();

  readonly selectedReport = computed(() => {
    const reports = this.reports();
    const selectedReportId = this.selectedReportId();

    if (!selectedReportId || reports.length === 0) {
      return null;
    }

    return reports.find(x => x.id === selectedReportId) ?? null;
  });

  onReportChange(report: ClientPowerBIReport): void {
    this.selected.emit(report);
  }

  onMenuTriggered(): void {
    setTimeout(() => {
      const selectedReport = document.getElementsByClassName(
        'selectedReport'
      )[0] as HTMLElement;

      selectedReport?.scrollIntoView({ block: 'start' });
    });
  }
}
